<template>
  <div class="authentication-wrapper authentication-3">
    <div class="authentication-inner" style="height: 100vh; overflow: none">
      <!-- Side container -->
      <!-- Do not display the container on extra small, small and medium screens -->
      <div class="col-lg-8 p-0 d-none d-lg-block">
            <!-- swiper -->
            <swiper :options="swiperOption" style="height: 100vh">
              <div
                class="parallax-bg"
                slot="parallax-bg"
                data-swiper-parallax="-23%"
              ></div>
              <swiper-slide>
                <div class="title" data-swiper-parallax="-100">Screening Algorithms</div>
                <br />
                <div class="subtitle" data-swiper-parallax="-200">Best Screening algorithms at your service</div>
                <div class="text-default" data-swiper-parallax="-300">
                  <p class="mt-5">
                    With our easy to configure interface and semi-automated business flow you can have all our system benefits at your service.
                  </p>
                  <p>Powerful search of the full Acuris Risk Intelligence dataset
                    <ul class="pt-4">
                      <li class="mb-2">Intuitive and easy to use</li>
                      <li class="mb-2">Filters to screen out false positives</li>
                      <li class="mb-2">Detailed profiles</li>
                      <li class="mb-2">Secure, auditable user access</li>
                    </ul>
                  </p>
                </div>
                <div class="Slide-caption-image-right-vcenter">
                  <img src="/img/bg/p1sl1captionimage.png" alt="" style="height: 30vh">
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="title" data-swiper-parallax="-100">Clean and up to Date Database</div>
                <div class="subtitle pt-5 pb-3" data-swiper-parallax="-200">Data quality is our daily goal</div>
                <div class="text-default" data-swiper-parallax="-300">
                  <p>
                    Our main partner Acuris Risk Intelligence inc. is one of leading, unique and global intelligence data provider for Compliance professionals providing their proprietary data, journalistic and editorial content.
                  </p>
                  <p>
                    Constantly updated world-class dataset contains information of Individuals, corporations, politically exposed persons, sanctions data and reputational risk exposure.
                    <ul class="pt-4">
                      <li class="mb-2"> <strong>High risk individuals and organisations </strong>– 5m+ records</li>
                      <li class="mb-2"><strong>PEPs </strong>– 1.4m individuals covered</li>
                      <li class="mb-2"><strong>Sanctions </strong>– Currently active sanctions and historical data</li>
                    </ul>
                  </p>
                </div>
                <!-- <div class="Slide-Footer">
 <img src="/img/bg/AcurisFooter.jpg" style="height: 20vh">
                </div> -->
              </swiper-slide>
              <swiper-slide>
                <div class="title mb-5" data-swiper-parallax="-100">Universal Web Platform</div>
                <div class="subtitle mb-3" data-swiper-parallax="-200">Modern web technology and high security your way to success</div>
                <div class="text-default" data-swiper-parallax="-300">
                  <p>
                    Our system is developed using latest web technology and with today's best architectual aproach. System is fully configurable and suitable for today's Georgian regulations.
                  </p>
                </div>
              </swiper-slide>
              <div
                class="swiper-pagination swiper-pagination-white"
                slot="pagination"
              ></div>
              <div
                class="swiper-button-prev swiper-button-white"
                slot="button-prev"
              ></div>
              <div
                class="swiper-button-next swiper-button-white"
                slot="button-next"
              ></div>
            </swiper>
      </div>
      <!-- / Side container -->
      <router-view />
    </div>
  </div>
</template>
<!-- Page -->
<style src="@/vendor/styles/pages/authentication.scss" lang="scss"></style>
<script>
// components
import 'swiper/css/swiper.css'
// import login from './components/login'
// import passwordRecovery from './components/passwordRecovery'
// import register from './components/register'
export default {
  name: 'pages-authentication-login-v3',
  components: {
    // 'login-component': login
    //   'password-recovery-component': passwordRecovery,
    //   'register-component': register
  },
  data: () => ({
    AgileOptions: {
      navButtons: false,
      autoplaySpeed: 5000,
      autoplay: false,
      infinite: true,
      fade: true,
      pauseOnDotsHover: true,
      pauseOnHover: true,
      speed: 2000,
      responsive: [
        {
          breakpoint: 600,
          settings: {}
        },
        {
          breakpoint: 900,
          settings: {
            dots: true,
            infinite: false
          }
        }
      ]
    },
    swiperOption: {
      autoplay: {
        delay: 3600,
        disableOnInteraction: false
      },
      speed: 1000,
      // effect: 'fade',
      parallax: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    },
    credentials: {
      email: '',
      password: '',
      rememberMe: false
    }
  })
}
</script>
<style scoped>

  .swiper-slide {
    font-size: 18px;
    color:#fff;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 40px 60px;
    background-color: transparent!important;
    justify-content: space-around!important;
  }
  .parallax-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 130%;
    height: 100%;
    -webkit-background-size: cover;
    background-size: cover;
    background-position: center;
    background-image: linear-gradient(
      rgba(0, 0, 0, 0.5),
      rgba(0, 0, 0, 0.5)
    ),url(/img/bg/p1bgl1.jpg);
  }
  .swiper-slide .title {
    font-size: 41px;
    font-weight: 300;
  }
  .title-vcenter {
    font-size: 41px;
    font-weight: 300;
    top: 50%;
    position: absolute;
  }
  .swiper-slide .subtitle {
    font-size: 21px;
  }
  .swiper-slide .text-default {
    width: 100%;
    font-size: 14px;
    max-width: 75%;
    line-height: 1.3;
  }

   .swiper-slide .text-vcenter {
    width: 100%;
    font-size: 14px;
    max-width: 75%;
    line-height: 1.3;
    top: 50%;
    position: absolute
  }
  .swiper-slide .text-bottom {
    width: 100%;
    font-size: 14px;
    max-width: 75%;
    line-height: 1.3;
    bottom: 0%;
    position: absolute
  }
  .Slide-Footer{
    position: absolute;
    bottom: 0%;
    padding: 0;
    margin: 0;
    max-width: 100%;
  }
  .Slide-caption-image-right-vcenter{
    position: absolute;
    top: 50%;
    right: 5%;
  }
</style>
